export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const EMAIL_SENT_SUCCESS = "EMAIL_SENT_SUCCESS";
export const PASSWORD_RESET_SUCCESS = "PASSWORD_RESET_SUCCESS";

export const UPDATE_USER = "UPDATE_USER";
export const UPDATE_NAME = "UPDATE_NAME";
export const TWO_FACTOR_AUTH = "TWO_FACTOR_AUTH";

export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";

export const SET_MESSAGE = "SET_MESSAGE";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";
